import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SignUpModal.css';

const SignUpModal = ({ isOpen, closeModal }) => {
  const navigate = useNavigate();

  const handleCreateAccountClick = () => {
    navigate('/OnboardingProcess');
    closeModal();
  };

  return (
    isOpen && (
      <div className="SignUpModal-overlay">
        <div className="SignUpModal-content">
          <button className="SignUpModal-close" onClick={closeModal}>
            ×
          </button>
          <h2 className="SignUpModal-title">Get 1 Month Free Trial! 🚀</h2>
          <p className="SignUpModal-description">No credit card needed. Start exploring now!</p>
          <button className="SignUpModal-button" onClick={handleCreateAccountClick}>
            Create Account
          </button>
        </div>
      </div>
    )
  );
};

export default SignUpModal;
